export const topics = [
	{
		header: "Characters",
		path: "characters",
		image: "/assets/LukeSkywalker.jpeg"
	},
	{
		header: "Planets",
		path: "planets",
		image: "/assets/Planet.jpg"
	},
	{
		header: "Films",
		path: "films",
		image: "/assets/StarWarsFilm.jpg"
	},
	{
		header: "Species",
		path: "species",
		image: "/assets/Ewok.jpg"
	},
	{
		header: "Starships",
		path: "starships",
		image: "/assets/Starships.jpg"
	},
	{
		header: "Vehicles",
		path: "vehicles",
		image: "/assets/Vehicle.jpg"
	}
];
